// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8809 ? "700d6c82" : chunkId) + "." + {"1510":"e2a91c88e26503e5","2759":"211207d48a688222","8083":"e22a0436b6e167a1","8809":"20ee01af1b3afb5d","9383":"592f658f37450aec"}[chunkId] + ".js";
};